// Scheduled browser reminders for attendance actions.
// These fire client-side via the Notification API while the app is open and the
// user has granted notification permission — no server / FCM push involved.

export interface ReminderSlot {
  /** stable id used for the per-day "already fired" marker */
  slot: string
  /** 24h hour of the day the reminder should trigger */
  hour: number
  /** minute of the hour the reminder should trigger */
  minute: number
  title: string
  body: string
}

export const ATTENDANCE_REMINDERS: ReminderSlot[] = [
  {
    slot: 'checkin',
    hour: 9,
    minute: 30,
    title: 'Check-in reminder',
    body: 'Reminder: Please check in for the day.',
  },
  {
    slot: 'checkout',
    hour: 18,
    minute: 30,
    title: 'Check-out reminder',
    body: 'Reminder: Please check out before leaving.',
  },
]

/** Local YYYY-MM-DD key so each reminder fires at most once per calendar day. */
export function reminderDayKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function reminderStorageKey(slot: string, d: Date): string {
  return `sasha_reminder_${slot}_${reminderDayKey(d)}`
}
